import Shop from '../shop';

export default class Bank extends Shop {
    /**
     *
     */
    constructor() {
        super({
            name:                 'Bank',
            id:                   'Bank',
            coolDown:             4500,
            faClass:              'fa-bank',
            individualCostFactor: 1.11,
            baseEarnings:         1074000000.0,
            baseCosts:            25798901760.0,
            grade:                10
        });
    }
}
